export default "__VITE_ASSET__Cude6Huu__"